import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button, Intent } from '@blueprintjs/core';
import { toast } from 'react-toastify';
import { forgotPassword } from '../../../api/authApi';
import './css/forgotPassword.css';
import logoBackground from './css/img/Atual Clube - Marca_Laranja 1.svg'
import logo from './css/img/logo.svg';
import { lerTokenDoCookie } from '../../../shared/cookie-da-sessao';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfLoggedIn = () => {
      const tokenCookie = lerTokenDoCookie();

      if (tokenCookie) {
        navigate('/home');
      }
    };

    checkIfLoggedIn();
  }, [navigate]);

  const handleForgotPassword = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await forgotPassword(email);

      toast.success(response.message || 'Solicitação enviada com sucesso!');

      setEmail('');
    } catch (err) {
      console.error('Erro ao solicitar redefinição de senha:', err);

      toast.error(err instanceof Error ? err.message : 'Erro desconhecido. Tente novamente mais tarde.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='main-containt'>
      <img className='logo-background' src={logoBackground} alt="Logo do fundo" />
      <div className="form-container-auth">
        <img src={logo} alt="Logo Atual" />
        <form className="form-forgot" onSubmit={handleForgotPassword}>
          <div className="forgot-div">
            <h1 className="h1-forgot">Redefinir Senha</h1>
            <p className='p-auth'>Informe seu email para recuperar sua senha.</p>

            <div className="forgot-fields">
              <p>Digite seu e-mail:</p>
              <div className="nice-form-group forgot">
                <input
                  id="email"
                  name="email"
                  className="nice-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="exemplo@atualclube.org"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className="button-div auth">
              <Button type="submit" intent={Intent.PRIMARY} disabled={isLoading}>
                {isLoading ? 'Enviando...' : 'Enviar E-mail de Redefinição'}
              </Button>
            </div>
            <div className='login'>
              <Link to="/login">Fazer login</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
